import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Overlay from 'componentsV2/Hero/components/Overlay';
import HeroBackground from 'componentsV2/Hero/components/HeroBackground';
import ActionButtons from 'componentsV2/ActionButtons';
import Description from 'componentsV2/Hero/components/SeriesDescription';
import ContextPlayer from 'components/ContextPlayer';
import Headline from 'componentsV2/Headline';
import Logo from 'componentsV2/Logo';
import { AnonymousSeriesProcessor } from '../../processors';
import style from './AnonymousSeriesView.module.scss';

const AnonymousSeries = ({
  analytics,
  anonymousAccount,
  disableScroll,
  hasTrailer,
  isOffset,
  item,
  promos,
}) => {
  const [playerVisibility, setPlayerVisibility] = useState(false);
  const {
    backgroundProps,
    buttonArray,
    descriptionProps,
    logoProps,
    promoProps,
    playerProps,
    title,
  } = AnonymousSeriesProcessor({
    panel: item,
    analytics,
    additionalFunctions: { setPlayerVisibility, disableScroll },
    playerVisibility,
    hasTrailer,
    promos,
  });

  return (
    <>
      <ContextPlayer
        {...playerProps}
        anonymousAccount={anonymousAccount}
        onClickCTA={promoProps?.onClickCTA}
        promo={promoProps}
        theme={style}
        visibility={playerVisibility}
      />
      <HeroBackground theme={style} {...backgroundProps}>
        <Overlay theme={style} isOffset={isOffset}>
          <Logo theme={style} isSeries={backgroundProps?.isSeries} {...logoProps} />
          <Headline theme={style} text={title} />
          <Description theme={style} {...descriptionProps} isAnonymous />
          <ActionButtons buttons={buttonArray} theme={style} />
        </Overlay>
      </HeroBackground>
    </>
  );
};

AnonymousSeries.propTypes = {
  anonymousAccount: PropTypes.shape({}),
  analytics: PropTypes.shape({}).isRequired,
  continueWatchingItems: PropTypes.shape({}),
  disableScroll: PropTypes.func,
  hasTrailer: PropTypes.bool,
  isOffset: PropTypes.bool,
  item: PropTypes.shape({}),
  promos: PropTypes.arrayOf(PropTypes.shape({})),
};

export default AnonymousSeries;
